import type { components } from 'wg-api-sdk';

import ActionCallCustomer from './ActionCallCustomer';
import ActionLink from './ActionLink';
import ActionMailCustomer from './ActionMailCustomer';

type Props = {
  actions: Array<components['schemas']['OnesuranceAction']>;
};

export default function AdviceActions({ actions }: Props) {
  const sortedActions = actions.sort((a, b) => b.order - a.order);

  return (
    <div className="flex flex-wrap justify-end gap-1">
      {sortedActions.map((action) => {
        switch (action.type) {
          case 'CALL_CUSTOMER':
            return <ActionCallCustomer key={action.order} action={action} />;
          case 'MAIL_CUSTOMER':
            return <ActionMailCustomer key={action.order} action={action} />;
          case 'CALCULATE_QUOTE':
          case 'SEND_QUICKSCAN':
          case 'SEND_RISK_ANALYSIS':
            return <ActionLink key={action.order} action={action} />;
          default:
            return null;
        }
      })}
    </div>
  );
}
